<template>
  <BreadCrumb PageTitle="Respuestas" PageParent="Juegos" parentRoute="/game-list"/>
  <AnswerList :axios="$axios"/>
</template>

<script lang="ts">
import {defineComponent} from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AnswerList from "../../components/Answers/AnswerList/AnswerList.vue";

export default defineComponent({
  name: "AnswerListPage",
  components: {
    BreadCrumb,
    AnswerList,
  }
});
</script>